import { ClickAwayListener } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/MenuList";
import { UserWithSmopDetails } from "@saleor/auth";
import MenuLoginExistingAccount from "@saleor/navigation/components/MenuLoginExistingAccount/MenuLoginExistingAccount";
import React from "react";
import { FormattedMessage } from "react-intl";

export interface SaveAccountDialogProps {
  user: UserWithSmopDetails;
}

interface AccountMenuProps {
  useStyles: any;
  showMenu: boolean;
  setMenuState: (state: boolean) => void;
  handleViewerProfile: () => void;
  hasSellerMaster: any[];
  handleLogout: () => void;
  handleBusinessDetails: () => void;
  user: UserWithSmopDetails;
}

const AccountMenu: React.FC<AccountMenuProps> = ({
  useStyles,
  showMenu,
  setMenuState,
  handleViewerProfile,
  hasSellerMaster,
  handleLogout,
  handleBusinessDetails,
  user
}) => {
  const classes = useStyles({});
  return (
    <ClickAwayListener
      onClickAway={() => setMenuState(false)}
      mouseEvent="onClick"
    >
      <Menu
        style={{
          gridRowGap: 2
        }}
      >
        {!showMenu && (
          <MenuItem
            className={classes.userMenuItem}
            onClick={handleViewerProfile}
            data-test="accountSettingsButton"
          >
            <FormattedMessage
              defaultMessage="Account Settings"
              description="button"
            />
          </MenuItem>
        )}
        {hasSellerMaster.length ? (
          <MenuItem
            className={classes.userMenuItem}
            onClick={handleBusinessDetails}
            data-test="businessDetailsButton"
          >
            <FormattedMessage
              defaultMessage="Business Details"
              description="button"
            />
          </MenuItem>
        ) : (
          ""
        )}
        <MenuItem
          className={classes.userMenuItem}
          onClick={handleLogout}
          data-test="logOutButton"
        >
          <FormattedMessage defaultMessage="Logout" description="button" />
        </MenuItem>
        <MenuLoginExistingAccount
          user={user}
          setMenuState={setMenuState}
          handleLogout={handleLogout}
        />
      </Menu>
    </ClickAwayListener>
  );
};

export default AccountMenu;
